import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonButton, useIonRouter } from '@ionic/vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'returnButton',
  setup(__props) {

const { t } = useI18n({
      inheritLocale: true,
      useScope: 'global'
})

const router = useIonRouter();

function goBack(){
    router.back();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonButton), {
    class: "return-button max-width-button",
    shape: "round",
    size: "large",
    expand: "block",
    onClick: goBack
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('return')), 1)
    ]),
    _: 1
  }))
}
}

})